// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "application." + "51abc4b275c6f028c677" + ".css";
};